import {
  SET_CLAIM_FORM_DATA,
  SET_CLAIM_FORM_STATUS,
  RESET_CLAIM_FORM,
  SUBMIT_CLAIM_FORM,
  SUBMIT_CLAIM_FORM_SUCCESS,
  SUBMIT_CLAIM_FORM_ERROR,
  SET_CONSULTATION_FORM_DATA,
  SET_CONSULTATION_FORM_STATUS,
  RESET_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM_SUCCESS,
  SUBMIT_CONSULTATION_FORM_ERROR,
  SET_REGRET_FORM_DATA,
  SET_REGRET_FORM_STATUS,
  RESET_REGRET_FORM,
  SUBMIT_REGRET_FORM,
  SUBMIT_REGRET_FORM_SUCCESS,
  SUBMIT_REGRET_FORM_ERROR,
} from './action-types';
import ConsultasClient from '../../api/consultas';

// Claims Form Actions
export const setClaimFormData = (formData) => ({
  type: SET_CLAIM_FORM_DATA,
  payload: formData,
});

export const setClaimFormStatus = (status) => ({
  type: SET_CLAIM_FORM_STATUS,
  payload: status,
});

export const resetClaimForm = () => ({
  type: RESET_CLAIM_FORM,
});

export const submitClaimForm = (formData) => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_CLAIM_FORM });
    dispatch(setClaimFormStatus('sending'));

    try {
      const state = getState();
      const token = state.applicationState?.token;

      const mappedFormData = {
        ...formData,
        comentarios: formData.descripcion, // Mapear descripcion a comentarios
      };

      delete mappedFormData.descripcion;

      // Paso 1: Enviar reclamo a reclamoMarcaBlanca
      const reclamoResponse = await ConsultasClient.reclamoMarcaBlanca(mappedFormData, token);

      if (!reclamoResponse || reclamoResponse.error) {
        throw new Error('Error al enviar el reclamo');
      }

      // Paso 2: Enviar email de notificación a enviarMailReclamo
      const emailResponse = await ConsultasClient.enviarMailReclamo(mappedFormData, token);

      if (!emailResponse || emailResponse.error) {
        throw new Error('Error al enviar el email de notificación');
      }

      // Si ambas llamadas fueron exitosas
      dispatch({ type: SUBMIT_CLAIM_FORM_SUCCESS, payload: { reclamoResponse, emailResponse } });
      dispatch(setClaimFormStatus('success'));
    } catch (error) {
      console.error('Error en submitClaimForm:', error);
      dispatch({ type: SUBMIT_CLAIM_FORM_ERROR, payload: error.message });
      dispatch(setClaimFormStatus('error'));
    }
  };
};

// Consultation Form Actions
export const setConsultationFormData = (formData) => ({
  type: SET_CONSULTATION_FORM_DATA,
  payload: formData,
});

export const setConsultationFormStatus = (status) => ({
  type: SET_CONSULTATION_FORM_STATUS,
  payload: status,
});

export const resetConsultationForm = () => ({
  type: RESET_CONSULTATION_FORM,
});

export const submitConsultationForm = (formData) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_CONSULTATION_FORM });
    dispatch(setConsultationFormStatus('sending'));

    try {
      const response = await fetch('/api/consultations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        dispatch({ type: SUBMIT_CONSULTATION_FORM_SUCCESS, payload: result });
        dispatch(setConsultationFormStatus('success'));
      } else {
        throw new Error('Error en el envío del formulario');
      }
    } catch (error) {
      dispatch({ type: SUBMIT_CONSULTATION_FORM_ERROR, payload: error.message });
      dispatch(setConsultationFormStatus('error'));
    }
  };
};

// Regret Form Actions
export const setRegretFormData = (formData) => ({
  type: SET_REGRET_FORM_DATA,
  payload: formData,
});

export const setRegretFormStatus = (status) => ({
  type: SET_REGRET_FORM_STATUS,
  payload: status,
});

export const resetRegretForm = () => ({
  type: RESET_REGRET_FORM,
});

export const submitRegretForm = (formData) => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_REGRET_FORM });
    dispatch(setRegretFormStatus('sending'));

    try {
      const state = getState();
      const token = state.applicationState?.token;

      // Paso 1: Enviar consulta a consultaMarcaBlanca
      const consultaResponse = await ConsultasClient.consultaMarcaBlanca(formData, token);

      if (!consultaResponse || consultaResponse.error) {
        throw new Error('Error al enviar la consulta de arrepentimiento');
      }

      // Paso 2: Enviar email de notificación a enviarMailArrepentimiento
      const emailResponse = await ConsultasClient.enviarMailArrepentimiento(formData, token);

      if (!emailResponse || emailResponse.error) {
        throw new Error('Error al enviar el email de arrepentimiento');
      }

      // Si ambas llamadas fueron exitosas
      dispatch({ type: SUBMIT_REGRET_FORM_SUCCESS, payload: { consultaResponse, emailResponse } });
      dispatch(setRegretFormStatus('success'));
    } catch (error) {
      console.error('Error en submitRegretForm:', error);
      dispatch({ type: SUBMIT_REGRET_FORM_ERROR, payload: error.message });
      dispatch(setRegretFormStatus('error'));
    }
  };
};
